import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/app/(Guest)/community/[key]/components/Detail.jsx");
